// extracted by mini-css-extract-plugin
export var cardIcon = "_5k-5";
export var cardIconUnframed = "_5k-9";
export var checkboxCard = "_5k-0";
export var checkboxCardSelected = "_5k-4";
export var disabled = "_5k-2";
export var interactive = "_5k-1";
export var outerBorder = "_5k-3";
export var spacerMedium = "_5k-8";
export var spacerSmall = "_5k-7";
export var spacerXsmall = "_5k-6";